module.exports = __webpack_public_path__ + "img/vacation.9b16a5f8.svg";